import { Injectable } from "@angular/core";

type LOG_LEVEL = 'TRACE' | 'DEBUG' | 'INFO' | 'WARN' | 'ERROR';
type LOG_TYPE = 'HTTP' | 'INTERNAL';


@Injectable({ providedIn: 'root' })
export class TraceService {
    constructor() {
    }

    internal(data: any, error?: boolean) {
        //this.send(error ? 'ERROR' : 'TRACE', 'INTERNAL', data);
    }

    http(data: any, error?: boolean) {
        //this.send(error ? 'ERROR' : 'TRACE', 'HTTP', data);
    }

    send(level: LOG_LEVEL, type: LOG_TYPE, ...data: any[]) {

        const trace = {
            type,
            level,
            'creation-time': Date.now(),
            body: data,
            artifact: 'spa-identity-center'
        }

        if (level == "DEBUG") {
            console.debug(JSON.stringify(trace));
        } else if (level == "INFO") {
            console.info(JSON.stringify(trace));
        } else if (level == "WARN") {
            console.warn(JSON.stringify(trace));
        } else if (level == "ERROR") {
            console.error(JSON.stringify(trace));
        } else {
            console.trace(JSON.stringify(trace));
        }
    }
}